import { classes } from "../../../../../util/style-utils";
import GeaoFooter from "./GeaoFooter";

export default function GeaoLayout({
    children,
    header,
    subHeader,
    logoHref = "/onboarding-overview",
    partnerLogo,
    skipToContent = false
}) {
    return (
        <main id="wrapper" >
            {skipToContent && <a href="#main-content" className="skip-to-content">Skip to main content</a>}
            <header id="primary-header" role="banner">
                <div className="header-logo">
                    <a href={logoHref}>
                        <img className="companyLogo pl-2" data-tenant-branding-logo="true" src="https://aadcdn.msftauthimages.net/dbd5a2dd-m7upushe63t5mro-qoncxx7g0ffd-q0du4joa4qyehc/logintenantbranding/0/bannerlogo?ts=638435352267202102" alt="Company Logo" />
                    </a>
                    {partnerLogo}
                </div>
            </header>
            <div id="main-content" className="content" tabIndex={-1}>
                {header &&
                    <div className="page-header--wrapper">
                        <div className="container">
                            <div className={classes("page-header", !subHeader && "page-header--without-subheader")}>
                                <div className="page-header-left">
                                    <h2>{header}</h2>
                                    {subHeader && <h4>{subHeader}</h4>}
                                </div>
                            </div>
                        </div>
                    </div>
                }
                <div className="margin-top mx-auto">
                    {children}
                </div>
            </div>
            <GeaoFooter />
        </main>
    );
};
